import React, { Component } from 'react';
import axios from "axios";

import api from '../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../components/ParadigmaTable/ParadigmaTable"



class Proveedores extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "CUIT",
                    id: "cuit",
                    accessor: d => d.cuit,
                    show: true,
                },
                {
                    Header: "Descripción",
                    id: "descripcion",
                    accessor: d => d.descripcion,
                    show: false,
                },
                {
                    Header: "E-Mail",
                    id: "email",
                    accessor: d => d.email,
                    show: true,
                },
                {
                    Header: "Rubros",
                    id: "lista_rubros",
                    accessor: "lista_rubros",
                    show: true,
                },
                {
                    Header: "Dirección",
                    id: "direccion_completa",
                    accessor: "direccion_completa",
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'proveedores_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'proveedores_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'proveedores_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'proveedores_delete',
                    }
                ]}
                depth={1}
                apiUrl={api.proveedores.proveedores}
                columns={this.state.columns}
                exportUrl={api.proveedores.proveedores}
                title={"Proveedores"}
            />
        );
    }
}

export default Proveedores;



// WEBPACK FOOTER //
// ./src/views/Proveedores/Proveedores.js